import { useId, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { filterBoolean } from '~/utils/arrays';

export const useAccessibleAffixes = ({ prefix, suffix }: { prefix?: string; suffix?: string }) => {
  const prefixId = `prefix_${useId()}`;
  const suffixId = `suffix_${useId()}`;
  const { t } = useTranslation(['common']);

  const prefixProps = useMemo(
    () => ({
      id: prefixId,
      'aria-label': t('common:fields.prefixAriaLabel', { prefix }),
    }),
    [prefix, prefixId, t],
  );

  const suffixProps = useMemo(
    () => ({
      id: suffixId,
      'aria-label': t('common:fields.suffixAriaLabel', { suffix }),
    }),
    [suffix, suffixId, t],
  );

  const ariaDescribedBy = [prefix && prefixId, suffix && suffixId].filter(filterBoolean).join(' ');

  return { prefixProps, suffixProps, ariaDescribedBy };
};
